import ResourceTable from './ResourceTable'
import { renderContext } from './renderer'

const { Provider } = renderContext

export { ResourceTable, Provider, renderContext }
export default ResourceTable
